import manageSubscriptionComponent from './manage-subscription.component';
import routes from './manage-subscription.routes';

export default angular
  .module('fizyweb.paycell.manageSubscription', [])
  .component('fizyPaycellManageSubscription', manageSubscriptionComponent)
  .config(routes).name;



// WEBPACK FOOTER //
// src/app/manage-subscription/manage-subscription.module.ts